import React, { } from "react";
import Container from "../../General/Container/Container";
import PersonasPinItem from "./PersonasPinItem";
import { Skeleton } from "antd";

const PersonasOtherInfoGroup = ({
    title = "Title",
    data = {},
    style = {},
    classColor,
    loading,
    forPrint
}) => {
    return <Container className="minified-result-item dcol gap-5p" style={style}>
        {
            loading
                ? <Skeleton paragraph={{ rows: 5 }} active />
                : <>
                    <span className={`personas-otherinfo-title${classColor}`}>{title}</span>
                    {Object.keys(data?.[title] || {}).map((key) => {
                        if (!data[title][key].length) return null;
                        return <PersonasPinItem
                            title={key}
                            key={key}
                            list={data[title][key]}
                            classColor={classColor}
                            forPrint={forPrint}
                        />
                    })}
                </>
        }
    </Container>
}

export default PersonasOtherInfoGroup